import type { BreadcrumbState } from "../atlas/contexts/Breadcrumb/types";

const STORAGE_KEY = "sj:breadcrumbs";

export function readBreadcrumbState(): BreadcrumbState | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Migration: if root is the old string format (e.g., "learn"), discard and start fresh
    if (typeof parsed.root === "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeBreadcrumbState(state: BreadcrumbState): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // sessionStorage may be full or unavailable — fail silently
  }
}

export function clearBreadcrumbState(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
